export default {
  en: {
    'scouting': 'scouting',
    'find_new_staff_members': 'find new staff members',
    'scouts': 'scouts',
    'age': 'age',
    'position': 'position',
    'skill': 'skill',
    'talent': 'talent',
    'youth_player': 'youth player',
    'recruited_by': 'recruited by',
  }
};
